/**
 * Workspaces API client (PRIVATE fork) — LetPot Admin workspace bindings.
 *
 * `/api/workspaces` is a fork EXTRA_ROUTE (outside the AppType contract), so
 * this client uses authFetch, never `rpc`.
 */

import { authFetch } from './auth';

export interface WorkspaceBinding {
  email: string;
  name: string | null;
  bound_at: string;
  expires_at: string | null;
}

export interface WorkspaceInfo {
  id: string;
  name: string;
  provider: string;
  binding: WorkspaceBinding | null;
}

export async function fetchWorkspaces(): Promise<WorkspaceInfo[]> {
  try {
    const res = await authFetch('/api/workspaces');
    if (!res.ok) return [];
    return (await res.json()).workspaces ?? [];
  } catch {
    return [];
  }
}

export async function bindWorkspace(
  workspaceId: string,
  email: string,
  password: string,
): Promise<{ ok: boolean; binding?: { email: string; name: string | null; roles: string[] }; error?: string }> {
  const res = await authFetch(`/api/workspaces/${encodeURIComponent(workspaceId)}/bind`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Bind failed' }));
    return { ok: false, error: ('error' in err && err.error) || `Bind failed: ${res.status}` };
  }
  return res.json();
}

export async function unbindWorkspace(workspaceId: string): Promise<{ ok: boolean }> {
  const res = await authFetch(`/api/workspaces/${encodeURIComponent(workspaceId)}/bind`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`unbindWorkspace failed: ${res.status}`);
  return res.json();
}
